import React from 'react'
import { Route, Routes } from 'react-router'
import { useAuth } from '../context/AuthContext'
import UserGrievanceListPage from '../app/admin/grievance/pages/UserGrievanceListPage';
import GrievanceInspectorRoutes from './GrievanceInspectorRoutes';
import GrievanceSupervisorLandingPage from '../app/dashboard/pages/GrievanceSupervisorLandingPage';
import SearchGrievancePage from '../app/admin/grievance/pages/SearchGrievancePage';

import SupervisorPendingReportPage from '../app/admin/reports/pages/SupervisorPendingReportPage';
import SupervisorStatusReportPage from '../app/admin/reports/pages/SupervisorStatusReportPage';



function GrievanceSupervisorRoutes() {
  const {authUser} = useAuth();
  return (
    <>
      <Routes>
        {/* WhatApp User */}
        {authUser.role == 5 && <Route path="/" element={ <GrievanceSupervisorLandingPage /> }></Route>  }
        <Route path="/grievance/my-list" element={ <UserGrievanceListPage /> }></Route>

        <Route path="/grievance/my-pending-report" element={ <SupervisorPendingReportPage /> }></Route>
        <Route path="/grievance/my-status-report" element={ <SupervisorStatusReportPage /> }></Route>

        <Route path="/grievance/search" element={ <SearchGrievancePage /> }></Route>
        <Route path="/grievance/search/:phone" element={ <SearchGrievancePage /> }></Route>
      </Routes>
      <GrievanceInspectorRoutes/>
    </>
  )
}

export default GrievanceSupervisorRoutes
